export default __webpack_public_path__ + "static/media/22.891fc38b.jpg";